export default __webpack_public_path__ + "static/media/noun_childrens dentistry_3292443.2c08745b.png";